var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.scope === "LES"
        ? [
            _c(
              "div",
              { staticClass: "w-full flex gap-2 justify-end mb-2" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.showLessonPopup = true
                      },
                    },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-50",
                      attrs: { icon: "SearchIcon" },
                    }),
                    _c("span", { staticClass: "align-middle" }, [
                      _vm._v("Buscar aulas"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("lesson-popup", {
              attrs: { visible: _vm.showLessonPopup, "plan-id": _vm.id },
              on: {
                selected: _vm.attachLessons,
                close: function ($event) {
                  _vm.showLessonPopup = $event
                },
              },
            }),
            _c(
              "vs-table",
              {
                attrs: {
                  data: _vm.lessons,
                  "no-data-text": "Nenhuma aula vinculada",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var data = ref.data
                        return _vm._l(data, function (tr) {
                          return _c(
                            "vs-tr",
                            { key: "les-" + tr.id },
                            [
                              _c("vs-td", [_vm._v(_vm._s(tr.name))]),
                              _c("vs-td", [
                                _vm._v(_vm._s(tr.modality_name || "—")),
                              ]),
                              _c(
                                "vs-td",
                                [
                                  _c("feather-icon", {
                                    staticClass:
                                      "h-5 w-5 stroke-current text-danger",
                                    staticStyle: { cursor: "pointer" },
                                    attrs: { icon: "Trash2Icon" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.confirmDetachLesson(tr)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        })
                      },
                    },
                  ],
                  null,
                  false,
                  2904876257
                ),
              },
              [
                _c(
                  "template",
                  { slot: "thead" },
                  [
                    _c("vs-th", [_vm._v("Aula")]),
                    _c("vs-th", [_vm._v("Modalidade")]),
                    _c("vs-th", [_vm._v("Ação")]),
                  ],
                  1
                ),
              ],
              2
            ),
          ]
        : _vm.scope === "MOD"
        ? [
            _c(
              "div",
              { staticClass: "w-full flex gap-2 justify-end mb-2" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.showModalityPopup = true
                      },
                    },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-50",
                      attrs: { icon: "SearchIcon" },
                    }),
                    _c("span", { staticClass: "align-middle" }, [
                      _vm._v("Buscar modalidades"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("modality-popup", {
              attrs: { visible: _vm.showModalityPopup },
              on: {
                selected: _vm.attachModalities,
                close: function ($event) {
                  _vm.showModalityPopup = $event
                },
              },
            }),
            _c(
              "vs-table",
              {
                attrs: {
                  data: _vm.modalities,
                  "no-data-text": "Nenhuma modalidade vinculada",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var data = ref.data
                      return _vm._l(data, function (tr) {
                        return _c(
                          "vs-tr",
                          { key: "mod-" + tr.id },
                          [
                            _c("vs-td", [_vm._v(_vm._s(tr.name))]),
                            _c(
                              "vs-td",
                              [
                                _c("feather-icon", {
                                  staticClass:
                                    "h-5 w-5 stroke-current text-danger",
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { icon: "Trash2Icon" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.confirmDetachModality(tr)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      })
                    },
                  },
                ]),
              },
              [
                _c(
                  "template",
                  { slot: "thead" },
                  [
                    _c("vs-th", [_vm._v("Modalidade")]),
                    _c("vs-th", [_vm._v("Ação")]),
                  ],
                  1
                ),
              ],
              2
            ),
          ]
        : _c("div", { staticClass: "text-muted p-2" }, [
            _vm._v(" Este plano cobre "),
            _c("strong", [_vm._v("todas as aulas")]),
            _vm._v(
              " do estabelecimento. Aulas novas passam a valer automaticamente. "
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }